import { IDeductionItemRepository, IDeductionItemRepositoryResponse } from "@/core/repositories/deduction";
export class GetDeductionItemUseCase {
  constructor(private readonly deductionItemRepository: IDeductionItemRepository) {}

  async execute(params: { deduction_id: number }, fetchPolicy?: { refetch: boolean }): Promise<IDeductionItemRepositoryResponse> {
    return this.deductionItemRepository.getDeductionItems(params, fetchPolicy);
  }
}
